<template>
    <b-col v-if="getIsColliDimension && shipment.collis.length > 0">
        <b-row class="mb-2" v-if="getIsColliDimension">
            <b-col sm="2">
                <div
                    v-if="display(fieldNames.PACKAGING_TYPE)"
                >{{ $t('createShipment.label.Packing') }}</div>
            </b-col>
            <b-col sm="2">{{ $t('createShipment.label.Weight') }}</b-col>
            <b-col sm="2">{{ $t('createShipment.label.Length') }}</b-col>
            <b-col sm="2">{{ $t('createShipment.label.Width') }}</b-col>
            <b-col sm="2">{{ $t('createShipment.label.Height') }}</b-col>
            <b-col
                sm="2"
                v-if="display(fieldNames.DRY_ICE)"
            >{{ $t('createShipment.label.Dryice') }}</b-col>
        </b-row>

        <b-row
            class="mb-2"
            v-for="(c, i) in this.shipment.collis"
            :key="`colli-${i}`"
        >
            <b-col sm="2">
                <div v-if="display(fieldNames.PACKAGING_TYPE)">
                    <vSelect
                        :dynamicWidth="true"
                        :options="listOfPackagingTypes"
                        :select-on-tab="true"
                        label="name"
                        :name="'shipment.collis[' + i + '].packagingId'"
                        :placeholder="$t('createShipment.placeholder.Choose Packaging')"
                        @input="updateColliValues(c, i)"
                        :reduce="(p) => p.id"
                        v-model="c.packagingId"
                        v-if="listOfPackagingTypes.length > 0"
                        :clearable="false"
                    />
                </div>
            </b-col>
            <b-col sm="2">
                <b-input-group
                    size="sm"
                    :append="weightUnit()"
                    :name="'shipment.collis[' + i + '].weight.group'"
                >
                    <b-form-input
                        :value="c.weight"
                        @change="setWeight(c,$event)"
                        type="text"
                        :name="'shipment.collis[' + i + '].weight'"
                        :class="{
                            'is-invalid': v.shipment.collis.$each[i].weight.$error
                        }"
                        @update="v.shipment.collis.$each[i].weight.$touch()"
                    />
                </b-input-group>
                <validationBetween
                    class="validation-error"
                    fieldName="createShipment.label.Weight"
                    :fieldValid="v.shipment.collis.$each[i].weight.between"
                    :fieldMin="v.shipment.collis.$each[i].weight.$params.between.min"
                    :fieldMax="v.shipment.collis.$each[i].weight.$params.between.max"
                    :name="'shipment.collis[' + i + '].weight.error'"
                    v-if="v.shipment.collis.$each[i].weight.$anyDirty"
                />
            </b-col>
            <b-col sm="2">
                <b-input-group
                    size="sm"
                    :append="dimensionsUnit()"
                    :name="'shipment.collis[' + i + '].length.group'"
                >
                    <b-form-input
                        v-model.number="c.length"
                        type="number"
                        :name="'shipment.collis[' + i + '].length'"
                        :disabled="c.isLengthLocked"
                        min="0"
                        :class="{
                            'is-invalid': v.shipment.collis.$each[i].length.$error
                        }"
                        @update="v.shipment.collis.$each[i].length.$touch()"
                    />
                </b-input-group>
                <validationField
                    fieldName="createShipment.label.Length"
                    :validator="v.shipment.collis.$each[i].length"
                    :name="'shipment.collis[' + i + '].length.error'"
                    v-if="v.shipment.collis.$each[i].length.$anyDirty"
                />
            </b-col>
            <b-col sm="2">
                <b-input-group
                    size="sm"
                    :append="dimensionsUnit()"
                    :name="'shipment.collis[' + i + '].width.group'"
                >
                    <b-form-input
                        v-model.number="c.width"
                        type="number"
                        :name="'shipment.collis[' + i + '].width'"
                        :disabled="c.isWidthLocked"
                        min="0"
                        :class="{
                            'is-invalid': v.shipment.collis.$each[i].width.$error
                        }"
                        @update="v.shipment.collis.$each[i].width.$touch()"
                    />
                </b-input-group>
                <validationField
                    fieldName="createShipment.label.Width"
                    :validator="v.shipment.collis.$each[i].width"
                    :name="'shipment.collis[' + i + '].width.error'"
                    v-if="v.shipment.collis.$each[i].width.$anyDirty"
                />
            </b-col>
            <b-col sm="2">
                <b-input-group
                    size="sm"
                    :append="dimensionsUnit()"
                    :name="'shipment.collis[' + i + '].height.group'"
                >
                    <b-form-input
                        v-model.number="c.height"
                        type="number"
                        :name="'shipment.collis[' + i + '].height'"
                        :disabled="c.isHeightLocked"
                        min="0"
                        :class="{
                            'is-invalid': v.shipment.collis.$each[i].height.$error
                        }"
                        @update="v.shipment.collis.$each[i].height.$touch()"
                    />
                </b-input-group>
                <validationField
                    fieldName="createShipment.label.Height"
                    :validator="v.shipment.collis.$each[i].height"
                    :name="'shipment.collis[' + i + '].height.error'"
                    v-if="v.shipment.collis.$each[i].height.$anyDirty"
                />
            </b-col>
            <b-col sm="2" v-if="display(fieldNames.DRY_ICE)">
                <b-input-group
                    size="sm"
                    :append="weightUnit()"
                    :name="'shipment.collis[' + i + '].dryIce.group'"
                >
                    <b-form-input
                        v-model.number="c.dryIce"
                        type="number"
                        :name="'shipment.collis[' + i + '].dryIce'"
                        min="0"
                        :class="{
                            'is-invalid': v.shipment.collis.$each[i].dryIce.$error
                        }"
                        @update="v.shipment.collis.$each[i].dryIce.$touch()"
                    />
                </b-input-group>
                <validationBetween
                    class="validation-error"
                    fieldName="createShipment.label.Dryice"
                    :fieldValid="v.shipment.collis.$each[i].dryIce.between"
                    :fieldMin="v.shipment.collis.$each[i].dryIce.$params.between.min"
                    :fieldMax="v.shipment.collis.$each[i].dryIce.$params.between.max"
                    :name="'shipment.collis[' + i + '].dryIce.error'"
                />
            </b-col>
            <b-col v-if="shipmentPackagingActive">
                <a
                    href="#"
                    v-if="i === 0"
                    @click="clear(c)"
                    :name="'shipment.collis[' + i + '].clear'"
                >Clear</a>
                <font-awesome-icon
                    v-else
                    icon="minus-circle"
                    size="lg"
                    color="#dc3545"
                    :name="'shipment.collis[' + i + '].remove'"
                    @click="remove(i)"
                />
            </b-col>
        </b-row>
    </b-col>
</template>

<script>
  import vSelect from './vSelect';
  import 'vue-select/dist/vue-select.css';
  import viewOptions from '../mixins/viewOptionsMixin';
  import localization from '../mixins/localizationMixin';
  import { ACTIONS, CREATE_SHIPMENT_PREFIX, GETTERS } from '../store/constants';
  import { FIELD_NAMES } from '../store/nameConstants';
  import validationField from './Validation/ValidationField';
  import validationBetween from './Validation/ValidationBetween';
  import validationDecimal from './Validation/ValidationDecimal';
  import { mapGetters } from 'vuex';
  export default {
      components: {
          vSelect,
          validationBetween,
          validationDecimal,
          validationField,
      },

      mixins: [viewOptions, localization],

      props: {
          shipment: {
              required: true,
          },
          v: { required: true },
      },

      watch: {
          'shipment.collis': {
              deep: true,
              handler() {
                  this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
                  );
              },
          },
          'shipment.colliDetails': {
              deep: true,
              handler() {
                  this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
                  );
              },
          },
      },

      data() {
          return {
              lockLength: false,
              lockWidth: false,
              lockHeight: false,
              fieldNames: FIELD_NAMES,
          };
      },

      methods: {
          decimalSeparator() {
            let n = 1.1;
            n = n.toLocaleString().substring(1, 2);
            return n;
          },
          setWeight(item, value) {
              let decimalSeparator = this.decimalSeparator();
              value = value.replace(',', '.');
              let number = parseFloat(value);
              item.weight = number;
              if (number > 50) {
                  this.shipment.shipmentOptions.hasPallet = true;
              } else {
                  this.SetPalletFlagForCollis()
              }
          },
          SetPalletFlagForCollis(){
            this.shipment.shipmentOptions.hasPallet = false;
            this.shipment.collis.forEach((element) => {

              let p = this.$store.state.createShipment.packagingTypes.find((obj) => {
                return obj.id === element.packagingId;
              });
              
              if (element.weight > 50 || p.name.toUpperCase().startsWith('PL')) {
                this.shipment.shipmentOptions.hasPallet = true;
              }
            });
          },
          clear(el) {
              let totalWeight = this.shipment.colliDetails.totalWeight;
              this.shipment.colliDetails.totalWeight = totalWeight - el.weight;

              el.weight = 0;
              el.length = 0;
              el.width = 0;
              el.height = 0;
              el.dryIce = 0;
          },
          remove(index) {
              this.shipment.collis.splice(index, 1);
              this.shipment.colliDetails.numberOfColli--;
          },

          updateColliValues(element, index) {
              const p = this.$store.state.createShipment.packagingTypes.find((obj) => {
                  return obj.id === element.packagingId;
              });
              
              if (p.currencyCode){
                this.shipment.customsAmount.currencyCode = p.currencyCode;  
              }
            
              this.$set(this.shipment.collis, index, {
                  weight: 0,
                  length: p.length,
                  width: p.width,
                  height: p.height,
                  dryIce: 0,
                  customPackageType: '',
                  packageType: p.packageType,
                  packagingId: p.id,
                  isHeightLocked: p ? p.isHeightLocked : false,
                  isLengthLocked: p ? p.isLengthLocked : false,
                  isWidthLocked: p ? p.isWidthLocked : false,
                  
              });

              // Automatically set hasPallet to true if packaging name starts with "PL"
              this.SetPalletFlagForCollis()
          },
      },

      computed: {
          listOfPackagingTypes() {
              return this.$store.state.createShipment.packagingTypes;
          },
          shipmentPackagingActive() {
              return this.$store.getters[
                  CREATE_SHIPMENT_PREFIX + GETTERS.CREATE_SHIPMENT.SHIPMENTPACKAGING_ACTIVE
              ];
          },
          ...mapGetters('createShipment', ['getIsColliDimension']),
      },
  };
</script>

<style></style>
